var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatFloor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6029 12.0802C49.6832 12.0802 49.7634 12.0802 49.8436 12.1604C49.9238 12.2407 50.004 12.3209 50.0843 12.4011C50.1645 12.4813 50.2447 12.6418 50.2447 12.8022C50.2447 12.9626 50.3249 13.1231 50.3249 13.2835V62.138C50.3249 62.2984 50.3249 62.4589 50.2447 62.6193C50.2447 62.7797 50.1645 62.9402 50.0843 63.0204C50.004 63.1006 49.9238 63.2611 49.8436 63.2611C49.7634 63.2611 49.6832 63.3413 49.6029 63.3413H45.9128C45.8326 63.3413 45.7523 63.3413 45.6721 63.2611C45.5919 63.1808 45.5117 63.1006 45.4315 63.0204C45.3512 62.9402 45.271 62.7797 45.271 62.6193C45.271 62.4589 45.1908 62.2984 45.1908 62.138V55.1588H42.1424V62.138C42.1424 62.2984 42.1424 62.4589 42.0622 62.6193C42.0622 62.7797 41.982 62.9402 41.9017 63.0204C41.8215 63.1006 41.7413 63.2611 41.6611 63.2611C41.5809 63.3413 41.5006 63.3413 41.4204 63.3413H25.9378C25.8576 63.3413 25.7774 63.3413 25.6971 63.2611C25.6169 63.1808 25.5367 63.1006 25.4565 63.0204C25.3763 62.9402 25.296 62.7797 25.296 62.6193C25.296 62.4589 25.2158 62.2984 25.2158 62.138V13.2033C25.2158 13.0429 25.2158 12.8824 25.296 12.722C25.296 12.5615 25.3763 12.4813 25.4565 12.3209C25.5367 12.2407 25.6169 12.0802 25.6971 12.0802C25.7774 12 25.8576 12 25.9378 12H49.6029V12.0802Z",
    fill: "#F78670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8003 13.5253H26.5791V63.3424H40.698V55.8818C40.698 55.7214 40.698 55.5609 40.7782 55.4005C40.7782 55.2401 40.8584 55.0796 40.9386 54.9994C41.0188 54.9192 41.0991 54.839 41.1793 54.7587C41.2595 54.6785 41.3397 54.6785 41.4199 54.6785H45.9123C45.9925 54.6785 46.0727 54.6785 46.153 54.7587C46.2332 54.839 46.3134 54.9192 46.3936 54.9994C46.4738 55.0796 46.5541 55.2401 46.5541 55.4005C46.5541 55.5609 46.6343 55.7214 46.6343 55.8818V63.3424H48.8805V13.5253H48.8003Z",
    fill: "#F78670"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0134 15.1272H36.4463V17.2932H39.0134V15.1272Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7935 15.1271H29.3066V17.293H31.8737V15.1271H31.7935Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2331 15.1272H43.666V17.2932H46.2331V15.1272Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0134 42.5677H36.4463V44.7337H39.0134V42.5677Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7935 42.5677H29.3066V44.7337H31.8737V42.5677H31.7935Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2331 42.5677H43.666V44.7337H46.2331V42.5677Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0134 49.4663H36.4463V51.6323H39.0134V49.4663Z",
    stroke: "#02475E",
    strokeWidth: 0.802208,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7935 49.4663H29.3066V51.6323H31.8737V49.4663H31.7935Z",
    stroke: "#02475E",
    strokeWidth: 0.802208,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2331 49.4663H43.666V51.6323H46.2331V49.4663Z",
    stroke: "#02475E",
    strokeWidth: 0.802208,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0134 22.0276H36.4463V24.1935H39.0134V22.0276Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7935 22.0275H29.3066V24.1935H31.8737V22.0275H31.7935Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2331 22.0276H43.666V24.1935H46.2331V22.0276Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0134 28.8492H36.4463V31.0151H39.0134V28.8492Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7935 28.8492H29.3066V31.0151H31.8737V28.8492H31.7935Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2331 28.8492H43.666V31.0151H46.2331V28.8492Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0134 35.7461H36.4463V37.9121H39.0134V35.7461Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7935 35.7462H29.3066V37.9121H31.8737V35.7462H31.7935Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2331 35.7461H43.666V37.9121H46.2331V35.7461Z",
    stroke: "#02475E",
    strokeWidth: 0.401104,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1545 63.3402H41.261C41.1808 63.3402 41.1006 63.26 41.1006 63.1797V54.5961C41.1006 54.5159 41.1808 54.4357 41.261 54.4357H46.1545C46.2347 54.4357 46.3149 54.5159 46.3149 54.5961V63.1797C46.3149 63.26 46.2347 63.3402 46.1545 63.3402Z",
    fill: "#02475E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7986 47.7775H21.659C20.7428 47.7775 20 48.5202 20 49.4365V51.5735C20 52.4897 20.7428 53.2325 21.659 53.2325H53.7986C54.7148 53.2325 55.4576 52.4897 55.4576 51.5735V49.4365C55.4576 48.5202 54.7148 47.7775 53.7986 47.7775Z",
    stroke: "#02475E",
    strokeWidth: 0.829493,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatFloor);
export default __webpack_public_path__ + "static/media/WhatFloor.72cb6eabb3b65230c820e4d78ec8749e.svg";
export { ForwardRef as ReactComponent };